export default "__VITE_ASSET__BmirbTk5__"